import { apiClient } from '@doda/api-client/util/apiClient';
import { SavedSearchRequest } from '@doda/api-client/aspida/@types';
import { createSearchConditionName } from '@doda/common/src/logics/saveCondition/saveCondition';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { AxiosError } from 'axios';

/**
 * 検索条件を最古のものに上書きする関数
 * @param {Object} params - パラメータオブジェクト
 * @param {Omit<SavedSearchRequest, 'name'>} params.conditions - 上書きする検索条件
 * @param {string} [params.redirectUrl] - 上書き失敗時のリダイレクトURL（任意）
 * @returns {Promise<void>} プロミス
 */
export const overwriteOldestCondition = async ({
  conditions,
  redirectUrl,
}: {
  conditions: Omit<SavedSearchRequest, 'name'>;
  redirectUrl?: string;
}) => {
  try {
    const searchConditionName = createSearchConditionName();
    const savedSearches = await apiClient.api.v1.savedSearches.$get();
    const [{ no }] = savedSearches.sort(
      (a, b) =>
        new Date(a.savedDate).getTime() - new Date(b.savedDate).getTime()
    );

    await apiClient.api.v1.savedSearches
      ._no(String(no))
      .put({ body: { ...conditions, name: searchConditionName } });
    window.location.href = `${DODA_SITE_URL.recommendJobList}?mpsc_dtno=${no}`;
  } catch (error) {
    const axiosError = error as AxiosError<{ message: string }>;
    window.DD_LOGS?.logger.error(
      `【上書き保存失敗】message:${axiosError.response?.data?.message} code:${
        axiosError.code
      } conditions: ${JSON.stringify(conditions)}`
    );
    if (redirectUrl) window.location.href = redirectUrl;
  }
};
